<mat-horizontal-stepper #stepper>
    @for (lotForm of lotForms; track lotForm; let index = $index) {
        <mat-step
            #lotStep="matStep"
            [stepControl]="lotForm"
            [hasError]="lotStep.interacted && lotForm.invalid"
            [completed]="lotStep.interacted && lotForm.valid"
        >
            <form [formGroup]="lotForm">
                <ng-template matStepLabel>{{ lotForm.get('LotName')?.value }}</ng-template>

                <div class="cb-margin-top-2x" style="display: flex; align-items: center; gap: 16px; flex-wrap: wrap;">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="cb-margin-top-2x" style="width: 400px;">
                        <mat-label>Use Existing Lot</mat-label>
                        <mat-select
                            [value]="getSelectedSourceLotId(index)"
                            [disabled]="isSourceLotMapped(index)"
                            (selectionChange)="handleExistingLotSelectionChange($event.value, index)"
                        >
                            <mat-option [value]="null">None</mat-option>
                            @for (lot of lotMappedItems; track lot) {
                                <mat-option [value]="lot.id" [disabled]="isSourceLotMappedByAnotherForm(lot.id, index)">
                                    #{{ lot.lotNumber }} - {{ lot.lotAddress?.street }}, {{ lot.lotAddress?.suburb }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (isSourceLotSelected(index)) {
                        <mat-checkbox
                            class="cb-margin-top-2x"
                            [checked]="isSourceLotMapped(index)"
                            (change)="handleSourceLotMappedChange(index, $event.checked)"
                        >
                            This existing lot is being migrated to this new lot
                        </mat-checkbox>
                    }
                </div>

                @if (isBlockForm(lotForm)) {
                    <cb-lot-migrator-block-form
                        [lotForm]="lotForm"
                        [addressRegions]="addressRegions"
                        [buildTypeOptions]="getBuildTypesForLotForm(lotForm)"
                        [contractTypes]="contractTypes"
                        [lotTypes]="lotTypes"
                    ></cb-lot-migrator-block-form>
                } @else if (isUnitForm(lotForm)) {
                    <cb-lot-migrator-unit-form
                        [lotForm]="lotForm"
                        [addressRegions]="addressRegions"
                        [buildTypeOptions]="getBuildTypesForLotForm(lotForm)"
                        [contractTypes]="contractTypes"
                        [lotTypes]="lotTypes"
                    ></cb-lot-migrator-unit-form>
                } @else {
                    <cb-lot-migrator-standalone-form
                        [lotForm]="lotForm"
                        [addressRegions]="addressRegions"
                        [buildTypeOptions]="getBuildTypesForLotForm(lotForm)"
                        [contractTypes]="contractTypes"
                        [lotTypes]="lotTypes"
                    ></cb-lot-migrator-standalone-form>
                }
            </form>
        </mat-step>
    }
</mat-horizontal-stepper>
